
<div class="d-flex flex-column p-5">
    <div class="row justify-content-around"><h2>Migration from file</h2></div>
    <div class="row justify-content-around"><h4>Migrating {{ migratingArr.length }} records</h4></div>
</div>
<div class="d-flex flex-column p-5">
    <div class="row justify-content-around"><h5>Succsessful transformations: {{ lecturesTransformArr.length }}</h5></div>
    <div class="row justify-content-around"><h5>Failed transformations: {{ failedLecturesTransformArr.length }}</h5></div>
</div>
<div class="d-flex w-98 row justify-content-center">
    <button class="btn btn-primary" >Start</button>
</div>
<div *ngIf="isFinished && lecturesMigrationArr && failedLecturesMigrationArr" class="d-flex flex-column p-5">
    <div class="row justify-content-around"><h5>Succsessful migrations: {{ lecturesMigrationArr.length }}</h5></div>
    <div class="row justify-content-around"><h5>Failed migrations: {{ failedLecturesMigrationArr.length }}</h5></div>
</div>
